import { render, staticRenderFns } from "./HealthPage.vue?vue&type=template&id=4c08faf0&"
import script from "./HealthPage.vue?vue&type=script&lang=ts&"
export * from "./HealthPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports